import * as Sentry from "@sentry/browser";

const DEFAULT_TRACES_SAMPLE_RATE = 0.05;
const MAX_LCP_BREADCRUMBS = 8;
let lcpBreadcrumbCount = 0;

function parseSampleRate(raw) {
  if (raw == null || String(raw).trim() === "") return DEFAULT_TRACES_SAMPLE_RATE;
  const n = Number(raw);
  if (!Number.isFinite(n) || n < 0 || n > 1) return DEFAULT_TRACES_SAMPLE_RATE;
  return n;
}

/**
 * Lightweight LCP signal in Sentry breadcrumbs (no extra npm deps). Best-effort only.
 */
function attachLcpBreadcrumbs() {
  if (typeof window === "undefined" || typeof PerformanceObserver === "undefined") {
    return;
  }
  try {
    const obs = new PerformanceObserver((list) => {
      for (const entry of list.getEntries()) {
        if (entry.entryType !== "largest-contentful-paint") continue;
        if (lcpBreadcrumbCount >= MAX_LCP_BREADCRUMBS) continue;
        lcpBreadcrumbCount += 1;
        const ms = Math.round(entry.startTime);
        Sentry.addBreadcrumb({
          category: "web-vitals",
          message: `LCP_ms:${ms}`,
          level: "info",
        });
      }
    });
    obs.observe({ type: "largest-contentful-paint", buffered: true });
  } catch (e) {
    console.warn("[Sentry] LCP observer failed", e);
  }
}

/**
 * Pillar 4: environment + release for release health and regression triage.
 * Set REACT_APP_SENTRY_RELEASE at build time (e.g. git SHA) in CI/production.
 * Optional REACT_APP_SENTRY_TRACES_SAMPLE_RATE (0–1) overrides default performance sampling.
 */
export const initSentry = () => {
  if (process.env.NODE_ENV === "production") {
    const environment =
      process.env.REACT_APP_ENVIRONMENT || process.env.NODE_ENV || "production";
    const release =
      process.env.REACT_APP_SENTRY_RELEASE ||
      process.env.REACT_APP_VERCEL_GIT_COMMIT_SHA ||
      "unified-app@unknown";

    const tracesSampleRate = parseSampleRate(process.env.REACT_APP_SENTRY_TRACES_SAMPLE_RATE);

    Sentry.init({
      dsn: "https://e60e858a354a42d88a5d71f742e1e77e@o384246.ingest.sentry.io/5215159",
      environment,
      release,
      tracesSampleRate,
    });

    attachLcpBreadcrumbs();
  }
};
